import React from 'react';
import PropTypes, { any } from 'prop-types';
import {
    ToggleSwitch,
} from '../../../Form';

const PreventProAmCategoryRegistration = (props) => {
    const {
        field,
        formApi,
        eventHasProAmConflicts,
        setShowPopup,
    } = props;

    return (
        <div className={`col-12`}>
            <ToggleSwitch
                id={'preventProAmDivisionRegistrationConflicts'}
                field={field}
                formGroupCssClass={`mb16`}
                label="Prevent players from registering for both a pro and amateur division"
                isEventEditForm={true}

                onChange={(val) => {
                    if (!val) {
                        formApi.setValue('preventProAmDivisionRegistrationConflicts', false);
                        formApi.setError(false);
                    }
                    if (val) {
                        if (eventHasProAmConflicts) {
                            setShowPopup(true);
                        }
                    }
                }}
                reverse={false}
            />
            <div className="div div16" />

        </div>
    );
};
PreventProAmCategoryRegistration.propTypes = {
    field: PropTypes.string.isRequired,
    formApi: PropTypes.objectOf(any).isRequired,
    eventHasProAmConflicts: PropTypes.bool,
    setShowPopup: PropTypes.bool,
};
PreventProAmCategoryRegistration.defaultProps = {
    eventHasProAmConflicts: false,
    setShowPopup: false,
};
export default PreventProAmCategoryRegistration;
